module.exports = __webpack_public_path__ + "static/logo-e1b4f721a300d2041e0b3ed656f6ccf4.svg";